<template>
  <div class="beefCont">
    <img src="../assets/imgs/94/bg.jpg" class="bg" alt="" />
    <Qrcode/>
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87578073" style="color:#fff">028-87578073</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 85.74rem;
    display: block;
  }
}
</style>